import { useState } from "react";
import { toast } from "sonner";
import { Star, ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";

export default function ReviewForm() {
  const { t } = useApp();
  const [f, setF] = useState({ name: "", location: "", rating: 5, text: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/testimonials/submit", f);
      toast.success(t.reviews.success);
      setF({ name: "", location: "", rating: 5, text: "" });
    } catch {
      toast.error(t.reviews.error);
    } finally { setLoading(false); }
  };
  const field = "w-full bg-transparent border-b border-slate-300 py-2.5 focus:outline-none focus:border-accent2 transition-colors";
  return (
    <form onSubmit={submit} data-testid="review-form" className="border border-slate-200 p-7 md:p-9 bg-white">
      <h3 className="font-display font-bold text-2xl">{t.reviews.formTitle}</h3>
      <p className="mt-2 text-slate-600 text-sm">{t.reviews.formSub}</p>
      <div className="mt-6 grid sm:grid-cols-2 gap-6">
        <div>
          <label className="text-xs uppercase tracking-widest text-slate-400">{t.reviews.name}</label>
          <input data-testid="review-name" required className={field} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-slate-400">{t.reviews.location}</label>
          <input data-testid="review-location" className={field} value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} />
        </div>
      </div>
      <div className="mt-6">
        <label className="text-xs uppercase tracking-widest text-slate-400">{t.reviews.rating}</label>
        <div className="flex gap-1.5 mt-2">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" data-testid={`review-star-${n}`} onClick={() => setF({ ...f, rating: n })} className="p-0.5">
              <Star size={24} className={n <= f.rating ? "fill-accent2 text-accent2" : "text-slate-300"} />
            </button>
          ))}
        </div>
      </div>
      <div className="mt-6">
        <label className="text-xs uppercase tracking-widest text-slate-400">{t.reviews.text}</label>
        <textarea data-testid="review-text" required rows={4} className={field + " resize-none"} value={f.text} onChange={(e) => setF({ ...f, text: e.target.value })} />
      </div>
      <button data-testid="review-submit" disabled={loading}
        className="mt-7 w-full inline-flex items-center justify-center gap-2 bg-brand text-white font-semibold px-6 py-3.5 hover:bg-accent2 transition-colors disabled:opacity-60">
        {loading ? t.reviews.sending : t.reviews.submit} <ArrowRight size={18} />
      </button>
    </form>
  );
}
